/* import __COLOCATED_TEMPLATE__ from './paragraph-sections.hbs'; */
import templateOnly from '@ember/component/template-only';
export default templateOnly();